
export function clearCache() {
    if (typeof caches !== "undefined") {
        caches.delete("hn-cache");
    }
}
